import React, { Component } from 'react';
import { View, Scene, Text } from 'core';
import { css, theme } from 'constants';
import RenderMsg from './chat/render_msg';

class Inactive extends Component {
  render() {
    const { selected } = this.props;
    const { reason, last_msg } = selected || {};
    return (
      <Scene style={{ alignItems: 'center', justifyContent: 'center' }}>
        <View style={{ marginTop: -80 }}>
          {RenderMsg(last_msg, 0, { messages: [last_msg] })}
          {reason ? (
            <View style={styles.reason}>
              <Text style={{ fontSize: theme.font_sm }}>
                Reason: <Text>{reason}</Text>
              </Text>
            </View>
          ) : null}
        </View>
      </Scene>
    );
  }
}
const styles = css({
  reason: {
    margin: 20,
    backgroundColor: theme.primary_color_lighten(),
    paddingHorizontal: 20,
    paddingVertical: 10,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 10
  }
});
export default Inactive;



// WEBPACK FOOTER //
// ./src/components/middle/inactive.js